/**
 * External dependencies
 */
import { createContext } from 'react';

/**
 * Internal dependencies
 */
import { SearchContextType } from './types';

export default createContext({} as SearchContextType);
